import { createAction } from '@reduxjs/toolkit';

export const UPDATE_USER_STATUS_ACTION_TYPE = 'saga/updateUserStatus';
export const updateUserStatusAction = createAction(UPDATE_USER_STATUS_ACTION_TYPE);
